export const cpscCoreFragment = `
  fragment cpscCoreFields on UsCpscPgaProgram {
    processingType
    certificateType
    globalIdentifier {
      code
      type
    }
    intendedUseDetails {
      code
      description
    }
    certificateDeclaration {
      certified
    }
  }
`;
